(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["detail-results"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = () => document.querySelectorAll('[data-vd-reveal]').forEach((root) => {
      if (root.dataset.vdReady) return;
      root.dataset.vdReady = 'true';
      const input = root.querySelector('input');
      const update = () => root.style.setProperty('--reveal', `${Math.min(100, Math.max(0, Number(input.value)))}%`);
      input.addEventListener('input', update);
      update();
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
    document.addEventListener('shopify:section:load', initialize);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["detail-review-wall"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = () => document.querySelectorAll('[data-vd-wall]').forEach((root) => {
      if (root.dataset.vdReady) return;
      root.dataset.vdReady = 'true';
      const dialog = root.querySelector('[data-vd-dialog]');
      let opener;
      root.querySelectorAll('[data-vd-review]').forEach((card) => {
        const key = `veymira-detail-vote-${root.dataset.vdWall}-${card.dataset.vdReview}`;
        let vote = '';
        try { vote = localStorage.getItem(key) || ''; } catch {}
        const buttons = [...card.querySelectorAll('[data-vote]')];
        buttons.forEach((button) => button.dataset.base = button.querySelector('[data-vd-count]').textContent);
        const update = () => buttons.forEach((button) => {
          const selected = button.dataset.vote === vote;
          button.setAttribute('aria-pressed', String(selected));
          button.querySelector('[data-vd-count]').textContent = Number(button.dataset.base) + Number(selected);
        });
        buttons.forEach((button) => button.addEventListener('click', () => {
          vote = vote === button.dataset.vote ? '' : button.dataset.vote;
          try { if (vote) localStorage.setItem(key, vote); else localStorage.removeItem(key); } catch {}
          update();
        }));
        card.querySelector('[data-vd-open]').addEventListener('click', (event) => {
          opener = event.currentTarget;
          root.querySelector('[data-vd-modal-content]').replaceChildren(card.querySelector('template').content.cloneNode(true));
          dialog.showModal();
        });
        update();
      });
      root.querySelector('[data-vd-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        const rect = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
      });
      dialog.addEventListener('close', () => opener?.focus());
      root.querySelector('[data-vd-more]')?.addEventListener('click', (event) => {
        const hidden = [...root.querySelectorAll('.vd-review--hidden')];
        const batch = Number(root.dataset.batch) || 3;
        hidden.slice(0, batch).forEach((card) => card.classList.remove('vd-review--hidden'));
        hidden[0]?.querySelector('[data-vd-open]')?.focus({ preventScroll: true });
        if (hidden.length <= batch) event.currentTarget.hidden = true;
      });
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
    document.addEventListener('shopify:section:load', initialize);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    const init = (root = document) => {
      root.querySelectorAll('.js-main-product').forEach((section) => {
        if (section.dataset.galleryReady) return;
        section.dataset.galleryReady = 'true';
        const gallery = section.querySelector('[data-product-gallery]');
        const mainButton = section.querySelector('[data-main-media]');
        const mainImage = mainButton?.querySelector('img');
        const thumbs = Array.from(section.querySelectorAll('[data-thumbnail]'));
        const track = section.querySelector('[data-thumbnail-track]');
        const previous = section.querySelector('[data-gallery-prev]');
        const next = section.querySelector('[data-gallery-next]');
        const status = section.querySelector('[data-gallery-status]');
        const dialog = section.querySelector('[data-media-dialog]');
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        let selected = 0;
        let swipeStart = null;
        let suppressClick = false;
        const select = (index) => {
          if (!mainImage || !thumbs.length) return;
          selected = Math.max(0, Math.min(thumbs.length - 1, index));
          const thumb = thumbs[selected];
          mainImage.removeAttribute('srcset');
          mainImage.removeAttribute('sizes');
          mainImage.src = thumb.dataset.image;
          mainImage.alt = thumb.dataset.alt || '';
          thumbs.forEach((item, i) => {
            item.classList.toggle('is-active', i === selected);
            item.setAttribute('aria-current', String(i === selected));
          });
          previous.disabled = selected === 0;
          next.disabled = selected === thumbs.length - 1;
          status.textContent = thumb.getAttribute('aria-label');
          const rect = thumb.getBoundingClientRect();
          const rail = track.getBoundingClientRect();
          track.scrollBy({ left: rect.left - rail.left - (rail.width - rect.width) / 2, behavior: reduceMotion ? 'auto' : 'smooth' });
          if (dialog?.open) dialog.querySelector('.media-dialog__image').style.backgroundImage = 'url("' + thumb.dataset.image + '")';
        };
        thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => select(index)));
        previous?.addEventListener('click', () => select(selected - 1));
        next?.addEventListener('click', () => select(selected + 1));
        gallery?.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'Home') select(0);
          else if (event.key === 'End') select(thumbs.length - 1);
          else select(selected + (event.key === 'ArrowRight' ? 1 : -1));
        });
        mainButton?.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'touch') swipeStart = { x: event.clientX, y: event.clientY };
        });
        mainButton?.addEventListener('pointerup', (event) => {
          if (!swipeStart) return;
          const dx = event.clientX - swipeStart.x;
          const dy = event.clientY - swipeStart.y;
          swipeStart = null;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4) {
            suppressClick = true;
            select(selected + (dx < 0 ? 1 : -1));
            window.setTimeout(() => { suppressClick = false; }, 450);
          }
        });
        mainButton?.addEventListener('pointercancel', () => { swipeStart = null; });
        mainButton?.addEventListener('click', () => {
          if (suppressClick || !dialog || !mainImage) return;
          const target = dialog.querySelector('.media-dialog__image');
          target.style.backgroundImage = 'url("' + (mainImage.currentSrc || mainImage.src) + '")';
          target.setAttribute('aria-label', mainImage.alt || '');
          dialog.showModal();
        });
        dialog?.querySelector('[data-media-close]')?.addEventListener('click', () => dialog.close());
        dialog?.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
        const submit = section.querySelector('[data-variant-submit]');
        section.querySelectorAll('[data-variant-radio]').forEach((radio) => radio.addEventListener('change', () => {
          if (!radio.checked || !submit) return;
          submit.disabled = radio.disabled;
          submit.textContent = radio.disabled ? submit.dataset.unavailableLabel : submit.dataset.availableLabel;
          const url = new URL(window.location.href);
          url.searchParams.set('variant', radio.value);
          window.history.replaceState({}, '', url);
        }));
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
    else init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-grid"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-reviews-section]').forEach((section) => {
    const dialog = section.querySelector('[data-review-modal]');
    const modalContent = section.querySelector('[data-review-modal-content]');
    const loadMore = section.querySelector('[data-load-more]');
    const storagePrefix = `veymira-review-vote-${section.dataset.reviewsSection}-`;
    const loadBatch = Number(section.dataset.loadBatch || 3);

    const openReview = (card) => {
      const template = card.querySelector('[data-review-content]');
      if (!dialog || !modalContent || !template) return;
      modalContent.innerHTML = template.innerHTML;
      dialog.showModal();
    };

    section.querySelectorAll('[data-review-card]').forEach((card) => {
      const reviewId = card.dataset.reviewId;
      const voteButtons = card.querySelectorAll('[data-vote]');
      let savedVote = '';
      try { savedVote = localStorage.getItem(storagePrefix + reviewId) || ''; } catch {}

      voteButtons.forEach((button) => {
        const baseCount = Number(button.querySelector('[data-count]')?.textContent || 0);
        button.dataset.baseCount = String(baseCount);
        if (savedVote === button.dataset.vote) {
          button.classList.add('is-selected');
          button.setAttribute('aria-pressed', 'true');
          button.querySelector('[data-count]').textContent = String(baseCount + 1);
        } else {
          button.setAttribute('aria-pressed', 'false');
        }

        button.addEventListener('click', (event) => {
          event.stopPropagation();
          const currentVote = savedVote;
          const nextVote = currentVote === button.dataset.vote ? '' : button.dataset.vote;
          savedVote = nextVote;
          try {
            if (nextVote) localStorage.setItem(storagePrefix + reviewId, nextVote);
            else localStorage.removeItem(storagePrefix + reviewId);
          } catch {}

          voteButtons.forEach((item) => {
            const count = Number(item.dataset.baseCount || 0) + (nextVote === item.dataset.vote ? 1 : 0);
            item.querySelector('[data-count]').textContent = String(count);
            item.classList.toggle('is-selected', nextVote === item.dataset.vote);
            item.setAttribute('aria-pressed', String(nextVote === item.dataset.vote));
          });
        });
      });

      card.addEventListener('click', (event) => {
        if (event.target.closest('button, a')) return;
        openReview(card);
      });
      card.addEventListener('keydown', (event) => {
        if (event.target.closest('button, a')) return;
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          openReview(card);
        }
      });
    });

    section.querySelector('[data-review-close]')?.addEventListener('click', () => dialog.close());
    dialog?.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    loadMore?.addEventListener('click', () => {
      const hiddenReviews = Array.from(section.querySelectorAll('[data-review-card].is-hidden'));
      hiddenReviews.slice(0, loadBatch).forEach((review) => review.classList.remove('is-hidden'));
      if (hiddenReviews.length <= loadBatch) loadMore.hidden = true;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
